import React from 'react';
import { observer } from 'mobx-react';
import classes from 'classnames';
import { VideoPlayer } from '../subject/video-player-decisions';
import { QuestionHeading } from './question-heading';

export const Decision = observer(
    ({
        ui,
        handleChange,
        enableAssessmentFinish,
        value,
        videoTokenRequested,
        videoPlayerUrl,
        token,
        playerPresetCaptionsLanguage,
        playerCaptionsSettings,
        canFastForward,
    }) => {
        const onChange = (decisionQuestionId, decision) => {
            if (decision) {
                let val = value || {};
                val[decisionQuestionId] = decision.key;

                handleChange(val, null, null, true);
            }
        };

        const logEvent = (subject, event_id, context, options) => {};

        return (
            <div className="section-exam">
                <div className={classes('assessment')}>
                    <div className={'assessment-question'}>
                        <QuestionHeading ui={ui} />
                        {ui.subject && ui.subject.type === 3 ? (
                            <VideoPlayer
                                videoTokenRequested={videoTokenRequested}
                                token={token && token.token}
                                videoPlayerUrl={videoPlayerUrl}
                                onChange={onChange}
                                enableAssessmentFinish={enableAssessmentFinish}
                                subject={ui.subject}
                                logEvent={logEvent}
                                presetCaptionsLanguage={
                                    playerPresetCaptionsLanguage
                                }
                                captionsSettings={playerCaptionsSettings}
                                canFastForward={canFastForward}
                                isAssessment
                            />
                        ) : (
                            <p>Failed to load player, no subject supplied</p>
                        )}
                    </div>
                </div>
            </div>
        );
    }
);
